export const faqList = [
  {
    id: 'faq-01',
    question: '蘑菇视频网页版需要下载安装吗？',
    answer: '不需要。蘑菇视频网页版是完全基于浏览器的在线视频平台，您只需在浏览器地址栏输入网址即可直接访问观看，无需下载任何软件或安装App，方便快捷。',
  },
  {
    id: 'faq-02',
    question: '蘑菇视频网页版支持哪些浏览器？',
    answer: '蘑菇视频网页版兼容所有主流浏览器，包括Google Chrome（推荐90+版本）、Microsoft Edge（90+）、Apple Safari（14+）、Mozilla Firefox（88+）等。建议使用最新版浏览器以获得最佳观看体验。',
  },
  {
    id: 'faq-03',
    question: '蘑菇视频网页版看视频需要付费吗？',
    answer: '蘑菇视频网页版提供大量免费视频内容，用户注册后即可免费观看。部分最新热播内容可能需要VIP会员，但平台会持续提供丰富的免费内容供用户观看。',
  },
  {
    id: 'faq-04',
    question: '手机能用蘑菇视频网页版吗？',
    answer: '完全可以。蘑菇视频网页版针对移动端浏览器做了专门优化，在手机Chrome、Safari等浏览器中打开会自动适配移动版界面。触控操作流畅，支持手势控制，观看体验与App相当。',
  },
  {
    id: 'faq-05',
    question: '蘑菇视频网页版打不开怎么办？',
    answer: '首先检查您的网络连接是否正常，可以尝试访问其他网站确认。如果网络正常，请尝试：1）清除浏览器缓存和Cookie；2）禁用广告拦截插件；3）更新浏览器到最新版本；4）切换网络环境后重试。具体排查步骤请参考我们的详细教程文章。',
  },
  {
    id: 'faq-06',
    question: '蘑菇视频网页版支持哪些清晰度？',
    answer: '蘑菇视频网页版支持流畅（360P）、标清（480P）、高清（720P）和超清（1080P）四个清晰度档位。系统会根据您的网络状况自动选择合适清晰度，您也可以在播放器右下角手动切换。部分内容还支持4K超高清画质。',
  },
  {
    id: 'faq-07',
    question: '蘑菇视频网页版可以下载视频离线观看吗？',
    answer: '蘑菇视频网页版主要提供在线观看功能。如果您需要离线下载功能，建议使用蘑菇视频App客户端。App支持视频缓存到本地，方便在没有网络的环境下观看。',
  },
  {
    id: 'faq-08',
    question: '蘑菇视频网页版支持投屏吗？',
    answer: '蘑菇视频网页版支持Chrome浏览器的Chromecast投屏功能。在播放页面点击投屏按钮（Chromecast图标），选择您的电视或投屏设备即可将视频投射到大屏幕上观看。',
  },
  {
    id: 'faq-09',
    question: '蘑菇视频网页版是否支持弹幕功能？',
    answer: '蘑菇视频网页版在部分视频内容中支持弹幕功能。观看视频时，您可以在播放器底部的弹幕开关中开启或关闭弹幕显示，也可以调整弹幕的透明度、速度和显示区域。',
  },
  {
    id: 'faq-10',
    question: '蘑菇视频网页版的观看记录会保存吗？',
    answer: '登录账号后，蘑菇视频网页版会自动保存您的观看历史和进度。您可以在"个人中心 - 观看历史"中查看和管理所有记录。未登录状态下，观看记录仅保存在当前浏览器中，清除浏览器数据后会丢失。',
  },
];